import { Component, OnInit } from '@angular/core';
import { PassDataService } from '../../services/pass-data.service';
import { SlokaBackendModel, SlokaTypeModel } from '../../interfaces/interfaces';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, filter, switchMap, first, take } from 'rxjs/operators';
import { SlokaLogicService } from '../../logic/sloka.service';
import { DashboardLogicService } from '../../logic/dashboard.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';

@Component({
  selector: 'slokas-list-pg',
  templateUrl: './slokas-list.component.html',
})
export class SlokasListPage implements OnInit {
  slokasList$: Observable<SlokaBackendModel[]> = new Observable<
  SlokaBackendModel[]
  >();
  slokaTypesList$: Observable<SlokaTypeModel[]> = new Observable<
  SlokaTypeModel[]
  >();

  page: number = 1;

  constructor(
    private passDataService: PassDataService,
    private slokaLogicService: SlokaLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.slokaTypesList$ = this.passDataService.getAllSlokaTypes();
    this.slokasList$ = this.passDataService.getAllSlokas();
  }

  onAddButtonClick() {
    this.router.navigate(['/page/add-sloka'], {
      state: { isAdd: true, isEdit: true, isView: false },
    });
  }

  setSlokaTypeId(slokaType: SlokaTypeModel) {
    if (typeof slokaType == 'undefined') {
      this.slokasList$ = this.passDataService.getAllSlokas();
    } else {
      this.slokasList$ = this.passDataService.getAllSlokas().pipe(
        switchMap((m) => {
          return [m.filter((f) => f.slokaTypeId == slokaType.id)];
        })
      );
    }
  }

  receivedAction(e: any) {
    e.isEdit &&
      this.router.navigate([`/page/sloka/${e.data.title}`], {
      state: { isAdd: false, isEdit: true, isView: false, data: e.data },
    });

    e.isView &&
      this.router.navigate([`/page/sloka/${e.data.title}`], {
      state: { isAdd: false, isEdit: false, isView: true, data: e.data },
    });

    e.isDelete &&
      this.passDataService.setPopup({
      isPopup: true,
      message: 'Are you sure to delete this Sloka?',
      isOk: false,
      isDelete: true,
      response: '',
    });

    e.isDelete &&
      this.passDataService
    .getPopupAction()
    .pipe(
      filter((a) => a != '' || a != null || typeof a != 'undefined'),
      map((b) => b == 'delete'),
      filter((c) => c),
      switchMap((d) => this.slokasList$),
      switchMap((l) => [l.filter((m) => e.data._id == m._id && m)]),
      switchMap((t) => this.slokaLogicService.deleteSlokaLogic(t[0]._id)),
      take(1)
    )
    .subscribe((v: any) => {
      v.message == 'sloka deleted succesfully' &&
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe() &&
        this.passDataService.setPopup({
        isPopup: true,
        message: 'Sloka is deleted successfully!',
        isOk: true,
        isDelete: false,
        response: '',
      });
    });
  }
}
